export default __webpack_public_path__ + "static/media/Dad joke.5490aee5.jpg";